import invalidateCanvasGraph from '@/hooks/canvas/helpers/invalidateCanvasGraph';
import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchCanvasOnVisualIdentityUpdateSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const CANVAS_VISUAL_IDENTITY_UPDATE_TOOL_NAMES = [
    'update_visual_identity',
    'canvases.updateVisualIdentity',
];

const buildRefetchCanvasOnVisualIdentityUpdateSubscription = (
    _params: BuildRefetchCanvasOnVisualIdentityUpdateSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-canvas-on-visual-identity-update',
        routePattern: '/agents/:agentId/canvas/:canvasId',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            if (
                !eventMatchesToolNames({
                    event,
                    toolNames: CANVAS_VISUAL_IDENTITY_UPDATE_TOOL_NAMES,
                })
            ) {
                return false;
            }

            const args = coerceToRecord({ value: event.args });
            const canvasIdFromArgs = getStringValue({ value: args.canvasId });

            if (!canvasIdFromArgs) {
                return true;
            }

            return canvasIdFromArgs === matchParams.canvasId;
        },
        action: ({ queryClient, matchParams }) => {
            invalidateCanvasGraph({
                queryClient,
                organizationId: matchParams.agentId,
                canvasId: matchParams.canvasId,
            });
        },
    };
};

export default buildRefetchCanvasOnVisualIdentityUpdateSubscription;
